import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CustoPessoalPorCentro, lerBuscaCustoPessoal } from '@/components/rateios/custo-pessoal';

export const Route = createFileRoute('/_app/custos/pessoal')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCustoPessoal(bruto),
  component: CustoPessoalRota,
});

function CustoPessoalRota() {
  const navigate = useNavigate();
  return (
    <CustoPessoalPorCentro
      busca={Route.useSearch()}
      onMudarCompetencia={(comp) => void navigate({ to: '/custos/pessoal', search: { comp }, replace: true })}
    />
  );
}
